module.exports = __webpack_public_path__ + "static/media/SearchIcon.b319adc7.svg";